import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/lib/api";
import { useAuth } from "@/lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login");
      return;
    }
    const sessionId = match[1];

    (async () => {
      try {
        const r = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        setUser(r.data.user);
        // Clear the hash and navigate
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { state: { user: r.data.user }, replace: true });
      } catch (e) {
        const status = e?.response?.status;
        const detail = e?.response?.data?.detail;
        if (status === 403) {
          toast.error(detail || "Acceso solo para el administrador.", { duration: 7000 });
          navigate("/", { replace: true });
          return;
        }
        toast.error("No pudimos iniciar sesión. Intenta de nuevo.");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-cream">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-warmgold border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-6 script text-warmgold text-2xl">Entrando a Fernebia...</p>
      </div>
    </div>
  );
}
